import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { BoroughNavigation, DefaultSelection36BoroughPayload, DefaultSelection36GlobalModulePayload, GlobalNavigation } from "../api-generated";
import { LoginUser } from "@aecom/core";

@Injectable()
export default class NavService {
  protected dataSubject = new BehaviorSubject<(DefaultSelection36BoroughPayload | DefaultSelection36GlobalModulePayload)[]>([]);

  data$: Observable<(DefaultSelection36BoroughPayload | DefaultSelection36GlobalModulePayload)[]> = this.dataSubject.asObservable();

  protected selectedSubject = new BehaviorSubject<DefaultSelection36BoroughPayload | DefaultSelection36GlobalModulePayload>(null);

  selectedItem$: Observable<DefaultSelection36BoroughPayload | DefaultSelection36GlobalModulePayload> = this.selectedSubject.asObservable();

  private broughDataSubject = new BehaviorSubject<BoroughNavigation[]>([]);

  broughDataSubject$: Observable<BoroughNavigation[]> =
    this.broughDataSubject.asObservable();

  private globalDataSubject = new BehaviorSubject<GlobalNavigation[]>([]);

  globalDataSubject$: Observable<GlobalNavigation[]> =
    this.globalDataSubject.asObservable();

  private userSubject = new BehaviorSubject<LoginUser>(null);

  user$: Observable<LoginUser> = this.userSubject.asObservable();

  setBroughData(item: BoroughNavigation[]): void {
    this.broughDataSubject.next(item);
  }

  getBroughData(): BoroughNavigation[] {
    return this.broughDataSubject.getValue();
  }

  setGlobalData(item: GlobalNavigation[]): void {
    this.globalDataSubject.next(item);
  }

  getGlobalData(): GlobalNavigation[] {
    return this.globalDataSubject.getValue();
  }

  setSelectedId(id: string): void {
    if (this.dataSubject.getValue()) {
      const items = this.dataSubject.getValue().filter((c) => c.Guid === id);
      if (items && items.length) {
        this.selectedSubject.next(items[0]);
      } else {
        this.selectedSubject.next(null);
      }
    }
  }

  getSelected(): DefaultSelection36BoroughPayload | DefaultSelection36GlobalModulePayload {
    return this.selectedSubject.getValue();
  }

  getrecentvalue(): (DefaultSelection36BoroughPayload | DefaultSelection36GlobalModulePayload)[] {
    return this.dataSubject.getValue();
  }

  setDataSubject(data: (DefaultSelection36BoroughPayload | DefaultSelection36GlobalModulePayload)[]): void {
    this.dataSubject.next(data);
  }

  getUser(): LoginUser {
    return this.userSubject.getValue();
  }

  setUser(user: LoginUser): void {
    this.userSubject.next(user);
  }

  setUserItem(firstName: string, lastName: string, id: string, email: string, companyName: string, permission: string[]): void {
    const user = new LoginUser(
      firstName,
      lastName,
      id,
      email,
      companyName,
      permission.join(),
    );
    this.userSubject.next(user);
  }
}
